
import { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import { recoverRealEstate } from "../../../services/Real_estate";
import { useNavigate } from "react-router-dom"; 
import StyleForAllPartsMy from "../StyleForAllParts/StyleForAllPartsMy";
import StyleForAllPartsNotMy from "../StyleForAllParts/StyleForAllPartsNotMy";


export default function Delete({ allDeleted, my, setEstateOn }) {
  useEffect(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }, []);
  const { brokerinfo } = useOutletContext();
  const navigate = useNavigate();
  const id = brokerinfo.broker_id || brokerinfo.manager_id;
  const count = allDeleted.filter(
    (item) => item.broker_id === id || item.manager_id === id,
  ).length;
  return (
    <div className="allElements">
      {my === true && <p>ԳՈՒՅՔԵՐԻ ՔԱՆԱԿԸ: {count}</p>}
      {my === false && (
        <p>
          ԳՈՒՅՔԵՐԻ ՔԱՆԱԿԸ: {count}/{allDeleted.length}
        </p>
      )}
      <div className="allelements">{allDeleted.map((el) => {
        const estateId =
          el?.apartment_id ?? el?.house_id ?? el?.land_id ?? el?.commercial_id;
        if (el.deleted === true) {
          if (my === true) {
            if (
              el.broker_id === brokerinfo.broker_id ||
              el.manager_id === brokerinfo.manager_id
            ) {
              return(<StyleForAllPartsMy
                el={el}
                estateId={estateId}
                setEstateOn={setEstateOn}
                navigate={navigate}
                id={id}
                brokerinfo={brokerinfo}
		 recoverRealEstate={recoverRealEstate}
              />)
            } else {
              return null;
            }
          } else {
            return(<StyleForAllPartsNotMy
              el={el}
              estateId={estateId}
              setEstateOn={setEstateOn}
              navigate={navigate}
              id={id}
              brokerinfo={brokerinfo}
  	      recoverRealEstate={recoverRealEstate}
            />)
          }
        } else return null;
      })}</div>
    </div>
  );
}
